const DITYPES = {
    LocalstorageService: Symbol.for('LocastorageService'),
    BrowserService: Symbol.for('BrowserService'),
    ApiService: Symbol.for('APIService'),
    LoggerService: Symbol.for('LoggerService'),
    UtilService: Symbol.for('UtilService'),
    OnboardingLookupService: Symbol.for('OnboardingLookupService'),
    NotificationService: Symbol.for('NotificationService'),
    ToastrService: Symbol.for('ToastrService'),
    PopupService:Symbol.for('PopupService'),
    GlobalErrorHandlerService:Symbol.for('GlobalErrorHandlerService')
  };
  
  export default DITYPES;